<template>
  <!-- eslint-disable -->
  <v-container fluid class="calamity-map-vue shared-maps" id="calamity-map-vue" style="padding: 0 !important;">
    <v-slide-y-transition mode="out-in">
      <div style="height: 100%;">
        <div style="display:none">{{drawerOpen()}}</div>
        <div id="map" class="map" style="height:100%; z-index:0;"></div>
        <v-card class="legend" :class="{'hidden-legend': !showLegend, 'shown-legend' : showLegend}">
          <v-card-title class="blue toggle-legend-btn"  @click="showLegend = !showLegend">
            <v-layout row style="margin: 0 -10px 0 0;">
              <v-flex class="vert-center" style="font-size: 15px;">Potential Calamity Map Legend</v-flex>
              <v-icon v-if="showLegend">arrow_drop_down</v-icon>
              <v-icon v-if="!showLegend">arrow_drop_up</v-icon>
            </v-layout>
          </v-card-title>
          <div class="filter-options">
            <v-layout style="padding: 0 20px 0 0; margin: 0;" >
              <v-select content-class="client-filter-list" class="client-filter-select" :items="ClientList" v-model="selectedClientId" prepend-icon="filter_list" item-text="SelectText" item-value="Id" label="Filter by Client" single-line :append-icon="selectedClientId == null ? '' : 'clear'" @click:append="() => {selectedClientId = null; selectedLocationId = null}"></v-select>
            </v-layout>
            <v-layout style="padding: 0 20px 0 0; margin: 0;" v-if="selectedClientId">
              <v-select content-class="location-filter-list" class="location-filter-select" :items="LocationList" v-model="selectedLocationId" prepend-icon="filter_list" item-text="SelectText" item-value="Id" label="Filter by Location" single-line :append-icon="selectedLocationId == null ? '' : 'clear'" @click:append="() => (selectedLocationId = null)"></v-select>
            </v-layout>
            <v-layout style="padding: 0 0 0 15px; margin: 0;" row v-for="i in transitStatus" :key="i.key">
              <v-icon :class="statusProperties[i.key].Class + '-icon'">label</v-icon>
              <v-flex xs6 class="vert-center" style="font-size: 14px;">{{i.label}}</v-flex>
              <a class="vert-center filter-icon"><v-icon @click="filterSingle(i.key)">filter_list</v-icon></a>
              <v-checkbox class="vert-center" :class="i.key + '-filter-btn'" v-model="transitFilter[i.key]" @change="filter()" style="margin: 0 0 0 15px; padding: 0; height: auto;"></v-checkbox>
            </v-layout>
            <v-layout row style="padding: 0 0 15px 15px; margin: 0;">
              <v-flex class="vert-center" style="font-size: 14px;">Showing Potential Calamities above {{minNumPackages}}.</v-flex>
            </v-layout>
            <v-layout row style="padding: 0 0 15px 15px; margin: 0;">
              <vue-slider class="num-package-slider" style="padding: 0; margin-bottom: 10px;" :tooltip="'focus'" v-model="minNumPackages" :min="0" :max="1000" :lazy="true" :width="'calc(100% - 15px)'"></vue-slider>
            </v-layout>
          </div>
        </v-card>
        <v-progress-circular class="progress-circle-loading" :size="55" :width="5" indeterminate color="primary" v-if="loading" ></v-progress-circular>
        <v-progress-circular class="progress-circle-refreshing" :size="30" :width="5" indeterminate color="primary" v-if="refreshing" ></v-progress-circular>
        <v-btn text icon class="fit-to-bounds-btn" color="grey darken-1" style="position: absolute; right: 0; top: 0;" @click="zoomToShowMarkers()">
          <v-icon dark>zoom_out_map</v-icon>
        </v-btn>
      </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>

<script>
import calamityMapModule, {
  CALAMITY_MAP_NAMESPACE
} from "./store/calamityMapStore";
import * as d3 from "d3";
import vueSlider from "vue-slider-component";
import MapsMixin from "@/mixins/MapsMixin.js";
import { mapGetters } from "vuex";

var transitFilter = {
  AtOrigin: true,
  InTransitArrived: true,
  InTransitDeparted: true,
  AtDestinationMetro: true,
  Exception: true
};

export default {
  name: "CalamityMap",
  components: {
    vueSlider
  },
  mixins: [MapsMixin],
  data() {
    return {
      map: null,
      transitFilter: transitFilter,
      minNumPackages: 0,
      transitStatus: [],
      selectedClientId: null,
      selectedLocationId: null,
      markerStats: {
        min: 1,
        max: 1
      },
      statusProperties: {},
      showLegend: true,
      loading: false,
      refreshing: false,
      // eslint-disable-next-line
      markerclusters: new L.MarkerClusterGroup({
        maxClusterRadius: 40,
        iconCreateFunction: this.defineClusterIcon,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: false,
        singleMarkerMode: true
      })
    };
  },
  computed: {
    ClientList() {
      var clients = _.cloneDeep(this.clientData);
      clients.forEach(client => {
        if (this.clientCount.hasOwnProperty("clientId" + client.Id)) {
          client.Total = this.clientCount["clientId" + client.Id];
        } else {
          client.Total = 0;
        }
        client.SelectText =
          client.Name + ": (" + client.Total.toLocaleString() + ")";
      });

      return clients.sort(function(a, b) {
        return b.Total - a.Total;
      });
    },
    LocationList() {
      var locations = this.getClientLocations();
      locations.forEach(location => {
        if (this.locationCount.hasOwnProperty("locationId" + location.Id)) {
          location.Total = this.locationCount["locationId" + location.Id];
        } else {
          location.Total = 0;
        }
        location.SelectText =
          location.Name + ": (" + location.Total.toLocaleString() + ")";
      });

      return locations.sort(function(a, b) {
        return b.Total - a.Total;
      });
    },
    ...mapGetters(CALAMITY_MAP_NAMESPACE, [
      "calamityMarkers",
      "clientData",
      "clientCount",
      "locationCount"
    ])
  },
  watch: {
    minNumPackages: /* istanbul ignore next */ function(val) {
      this.drawMarkers();
    },
    selectedClientId: /* istanbul ignore next */ function(val) {
      this.filter();
    },
    selectedLocationId: /* istanbul ignore next */ function(val) {
      this.filter();
    },
    drawer: /* istanbul ignore next */ function(val) {
      var grid = document.getElementById("calamity-map-vue");
      var direction = -1;
      if (!val) direction *= -1;
      var offset = this.$store.navWidth * 0.5 * direction;
      if (grid) this.map.panBy([offset, 0], { duration: 0.2 });
    }
  },
  mounted: /* istanbul ignore next */ function() {
    this.initCalamityMap();
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(CALAMITY_MAP_NAMESPACE, calamityMapModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.CALAMITY_ADMIN]).then(
      res => {
        if (res) {
          this.loadPackages();
          this.loadClients();
          this.initProperties();
          var self = this;
          var calamityMapInterval = setInterval(function() {
            self.refreshing = true;
            self.$store
              .dispatch(`${CALAMITY_MAP_NAMESPACE}/LOAD_WITH_FILTER`, {
                transitFilter: transitFilter,
                selectedClientId: self.selectedClientId,
                selectedLocationId: self.selectedLocationId
              })
              .then(x => {
                self.drawMarkers();
              });
          }, 5 * (60 * 1000));
          this.$store.intervals.calamityMapInterval = calamityMapInterval;
        } else this.$goHome();
      }
    );
  },
  methods: {
    initCalamityMap() {
      this.map = this.initMap();
      // Breaks Tests
      try {
        this.map.addLayer(this.markerclusters);
      } catch (e) {}
      var self = this;
      /* istanbul ignore next */
      this.map.on("zoomstart", function() {
        self.map.closePopup();
      });
      /* istanbul ignore next */
      this.map.on("zoomend", function() {
        self.markerStats = self.getShownMarkerTotals();
        self.markerclusters.refreshClusters();
      });
      /* istanbul ignore next */
      this.markerclusters
        .on("clusterclick", function(c) {
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                "Locations: " + c.layer._childCount.toLocaleString(),
                self.getClusterData(c.layer, {}),
                self.statusProperties
              )
            )
            .openOn(self.map);
        })
        .on("clustermouseover", function(c) {
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                "Locations: " + c.layer._childCount.toLocaleString(),
                self.getClusterData(c.layer, {}),
                self.statusProperties
              )
            )
            .openOn(self.map);
        })
        .on("clustermouseout", function(c) {
          self.map.closePopup();
        })
        .on("clusterdblclick", function(c) {
          self.map.fitBounds(c.layer.getBounds(), { padding: [75, 75] });
          setTimeout(() => {
            self.markerStats = self.getShownMarkerTotals();
            self.markerclusters.refreshClusters();
            self.map.closePopup();
          }, 1000);
        })
        .on("click", function(c) {
          var a = d3.selectAll(".marker-link");
          a.classed("no-pointer-events", true);
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                c.layer.feature.properties.Name,
                c.layer.feature.properties.Data,
                self.statusProperties,
                c.layer.feature.properties.HashKey
              )
            )
            .openOn(self.map);
          setTimeout(function() {
            var a = d3.selectAll(".marker-link");
            a.classed("no-pointer-events", false);
          }, 100);
        })
        .on("mouseover", function(c) {
          var a = d3.selectAll(".marker-link");
          a.classed("no-pointer-events", true);
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                c.layer.feature.properties.Name,
                c.layer.feature.properties.Data,
                self.statusProperties,
                c.layer.feature.properties.HashKey
              )
            )
            .openOn(self.map);
          setTimeout(function() {
            a.classed("no-pointer-events", false);
          }, 100);
        })
        .on("mouseout", function(c) {
          var a = d3.selectAll(".marker-link");
          a.classed("no-pointer-events", true);
          self.map.closePopup();
        });
    },
    loadPackages() {
      this.loading = true;
      return this.$store
        .dispatch(`${CALAMITY_MAP_NAMESPACE}/LOAD_PACKAGES`, transitFilter)
        .then(x => {
          this.drawMarkers();
        });
    },
    loadClients() {
      return this.$store.dispatch(`${CALAMITY_MAP_NAMESPACE}/LOAD_CLIENTS`);
    },
    getClientLocations() {
      let client = this.clientData.find(x => x.Id === this.selectedClientId);
      if (client) return client.Locations;
      return [];
    },
    filterSingle(key) {
      for (var propertyName in transitFilter) {
        if (
          this.statusProperties[propertyName].Priority >=
          this.statusProperties[key].Priority
        )
          transitFilter[propertyName] = true;
        else transitFilter[propertyName] = false;
      }
      transitFilter[key] = true;
      this.filter();
    },
    filter() {
      this.loading = true;
      this.$forceUpdate();
      this.$store
        .dispatch(`${CALAMITY_MAP_NAMESPACE}/FILTER`, {
          transitFilter: transitFilter,
          selectedClientId: this.selectedClientId,
          selectedLocationId: this.selectedLocationId
        })
        .then(x => {
          this.drawMarkers();
        });
    },
    drawMarkers() {
      var filteredMarkers = this.calamityMarkers.filter(x => {
        return x.properties.Total >= this.minNumPackages;
      });
      var data = {
        type: "FeatureCollection",
        features: filteredMarkers,
        properties: {}
      };
      // eslint-disable-next-line
      var points = L.geoJson(data, {
        pointToLayer: this.defineFeature
      });
      this.markerclusters.clearLayers();
      this.markerclusters.addLayer(points);
      this.markerStats = this.getShownMarkerTotals();
      this.markerclusters.refreshClusters();
      this.loading = false;
      this.refreshing = false;
    },
    defineFeature(feature, latlng) {
      var html = this.getLocationMarkerHtml({
        total: feature.properties.Total,
        infoboxClass: "infobox-marker-" + feature.properties.Id,
        svgClass: "svg-marker-" + feature.properties.Id,
        wedgeData: feature.properties.Data,
        label: feature.properties.Name,
        hashKey: feature.properties.HashKey,
        markerStats: this.markerStats,
        statusProperties: this.statusProperties
      });
      var sizes = this.getMarkerSizes(
        feature.properties.Total,
        this.markerStats
      );
      // eslint-disable-next-line
      var icon = new L.DivIcon({
        html: html,
        className: "marker-cluster",
        // eslint-disable-next-line
        iconSize: new L.Point(sizes.radius, sizes.radius)
      });
      // eslint-disable-next-line
      return L.marker(latlng, { icon: icon });
    },
    defineClusterIcon(cluster) {
      var children = cluster.getAllChildMarkers();
      var label = "Locations: " + children.length;
      if (children.length === 1) label = children[0].feature.properties.Name;
      var total = d3.sum(children, function(d) {
        return d.feature.properties.Total;
      });
      var wedgeData = {};
      for (let status in this.statusProperties) {
        wedgeData[status] = d3.sum(children, function(d) {
          return d.feature.properties.Data[status];
        });
      }
      var html = this.getLocationMarkerHtml({
        total: total,
        infoboxClass: "infobox-cluster-" + cluster._leaflet_id,
        svgClass: "svg-cluster-" + cluster._leaflet_id,
        wedgeData: wedgeData,
        label: label,
        numLocations: children.length,
        markerStats: this.markerStats,
        statusProperties: this.statusProperties
      });
      var className = "marker-cluster";
      if (children.length > 1) className += " multi-location-cluster";
      else className += " single-location-cluster";
      var sizes = this.getMarkerSizes(total, this.markerStats);
      // eslint-disable-next-line
      return new L.DivIcon({
        html: html,
        className: className,
        // eslint-disable-next-line
        iconSize: new L.Point(sizes.radius, sizes.radius)
      });
    },
    zoomToShowMarkers() {
      var filteredMarkers = this.calamityMarkers.filter(x => {
        return x.properties.Total >= this.minNumPackages;
      });
      if (filteredMarkers.length > 0) {
        var bounds = [];
        filteredMarkers.forEach(m => {
          /* istanbul ignore else */
          if (
            m.properties.Coords[0] !== 0 &&
            m.properties.Coords[1] !== 0 &&
            m.properties.Coords[0] &&
            m.properties.Coords[1]
          )
            bounds.push(m.properties.Coords);
        });
        var paddingLeft = 50;
        /* istanbul ignore next */
        if (this.drawerOpen()) paddingLeft = this.$store.navWidth + 50;
        this.map.fitBounds(bounds, {
          paddingTopLeft: [paddingLeft, 50],
          paddingBottomRight: [50, 50]
        });
      }
    },
    initProperties() {
      this.transitStatus = [];
      this.statusProperties = {};
      this.statusProperties = {
        AtOrigin: {
          Label: "At Origin",
          Class: "AtOriginStatus",
          Priority: 4
        },
        InTransitArrived: {
          Label: "In Transit Arrived",
          Class: "InTransitArrivedStatus",
          Priority: 3
        },
        InTransitDeparted: {
          Label: "In Transit Departed",
          Class: "InTransitDepartedStatus",
          Priority: 2
        },
        AtDestinationMetro: {
          Label: "At Destination Metro",
          Class: "AtDestinationMetroStatus",
          Priority: 1
        },
        Exception: {
          Label: "Exception",
          Class: "ExceptionStatus",
          Priority: 0
        }
      };

      for (let status in this.statusProperties) {
        this.transitStatus.push({
          label: this.statusProperties[status].Label,
          key: status
        });
      }
    }
  }
};
</script>
